import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getCountries, getCountriesWithClubs } from './thunks'

const countriesState: Countries = {
  countries: [],
  status: 'idle',
  error: null,
}

const initialState: CountriesContainer = {
  all: countriesState,
  withClubs: countriesState,
}

const slice = createSlice({
  name: 'countries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.all.status = 'loading'
        state.all.error = null
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.all.status = 'failed'
        state.all.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.all.status = 'succeeded'
        state.all.countries = action.payload
      })

    builder
      .addCase(getCountriesWithClubs.pending, (state) => {
        state.withClubs.status = 'loading'
        state.withClubs.error = null
      })
      .addCase(getCountriesWithClubs.rejected, (state, action) => {
        state.withClubs.status = 'failed'
        state.withClubs.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getCountriesWithClubs.fulfilled, (state, action) => {
        state.withClubs.status = 'succeeded'
        state.withClubs.countries = action.payload
      })
  },
})

export const selectCountries = (state: RootState): Countries => state.countries.all
export const selectCountriesWithClubs = (state: RootState): Countries => state.countries.withClubs

export default slice.reducer
